<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.00049 14.6667L2.00049 1.33335" stroke="black" stroke-linecap="round"/>
<path d="M14 14.6667L14 1.33335" stroke="black" stroke-linecap="round"/>
<rect x="6" y="4.33337" width="4" height="7.33331" rx="1" fill="black"/>
</svg>
